import { Event, events } from "@planzone/events";
import {
  DiscussionSubjectTypes,
  list,
  milestone,
  task,
  event as eventMock,
} from "@planzone/dto";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { reduceTask } from "../../common/task";
import { reduceEvent } from "../../common/event";
import { reduceMilestone } from "../../common/milestone";
import { reduceList } from "../../common/list";
import { reduceResource } from "../../common/resource";
import { Selector, State } from "./types";
import { initialState } from "./initialState";
import { handleRequest } from "./retrieveDiscussionsRequested";
import { handleSuccess } from "./retrieveDiscussionsSucceeded";
import { handleFailure } from "./retrieveDiscussionsFailed";
import { handlePostCommentRequest } from "./postCommentRequested";
import { handlePostCommentSuccess } from "./postCommentSucceeded";
import { handlePostCommentFailed } from "./postCommentFailed";
import { handleRemoveComment } from "./removeComment";
import { handleRemoveDiscussion } from "./removeDiscussion";
import { handleStartDiscussion } from "./startDiscussion";
import { createSelector } from "./selector";

function propagateEvent(state = initialState, event: Event): State {
  return state.map((req) => ({
    ...req,
    discussions: req.discussions.map((discussion) => ({
      ...discussion,
      subject:
        discussion.entityType === DiscussionSubjectTypes.TASK
          ? reduceTask({ ...task, ...discussion.subject }, event)
          : discussion.entityType === DiscussionSubjectTypes.EVENT
            ? reduceEvent({ ...eventMock, ...discussion.subject }, event)
            : discussion.entityType === DiscussionSubjectTypes.MILESTONE
              ? reduceMilestone({ ...milestone, ...discussion.subject }, event)
              : discussion.entityType === DiscussionSubjectTypes.LIST
                ? reduceList({ ...list, ...discussion.subject }, event)
                : (discussion as any).subject,
      comments: discussion.comments.map((comment) => ({
        ...comment,
        author: reduceResource(comment.author, event),
      })),
    })),
  }));
}

const reduceState = resetState(
  initialState,
  createStateReducer(
    initialState,
    {
      [events.retrieveDiscussionsRequested]: handleRequest,
      [events.retrieveDiscussionsSucceeded]: handleSuccess,
      [events.retrieveDiscussionsFailed]: handleFailure,
      [events.postCommentRequested]: handlePostCommentRequest,
      [events.postCommentSucceeded]: handlePostCommentSuccess,
      [events.postCommentFailed]: handlePostCommentFailed,
      [events.removeCommentSucceeded]: handleRemoveComment,
      [events.startDiscussionSucceeded]: handleStartDiscussion,
      [events.removeDiscussionSucceeded]: handleRemoveDiscussion,
    },
    propagateEvent,
  ),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
